import { Modal, notification } from "antd";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import moment from "moment";
import { Api } from "../../../common/Api";
import { FilterStore } from "../../FilterStore";

export class ArticlePublishesStore {
  filterStore: FilterStore;

  loading = false;

  filter: any = {
    page: 0,
    size: 20,
    articleId: "",
    keyword: "",
    period: [],
  };

  data = {
    total: 0,
    items: [],
  };

  article: any = {};

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new FilterStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    let period: string[] = [];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: 0 });
    history.push({ search: query.toString() });
  }

  @action onPage(history, page, pageSize) {
    const query = new URLSearchParams({ ...this.filter, page: page - 1, pageSize });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);

    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("pageSize") || "20");

    const periodStr = params.get("period") || "";
    const period = periodStr ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { articleId: this.filter.articleId, period, page, size };

    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { articleId, period, page, size } = this.filter;
    const filter: any = { articleId, page, size };

    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }

    Api.content.article.article(filter.articleId).then((res) => {
      runInAction(() => {
        this.article = res.data.article;
        console.log(this.article);
      });
    });

    return Api.content.article
      .publishes(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.articlePublishes;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }

  @action withdrawn(id) {
    console.log("id", id);
    Modal.confirm({
      title: "Are you sure withdrawn this?",
      onOk: () => {
        Api.content.article.withdrawn(id).then((res) => {
          notification.success({ message: "Successfully!" });
        });
      },
    });
  }
}

export const articlePublishesStore = new ArticlePublishesStore();
